import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["template", "list"]

  add(event) {
    event.preventDefault()
    const timestamp = new Date().getTime()
    const template = this.element.querySelector("template")
    const list = this.element.querySelector("[data-list]")
    const html = template.innerHTML.replace(/TEMPLATE_INDEX/g, timestamp)
    list.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-correctie-row]")
    const destroyField = row.querySelector("input[name*='_destroy']")
    if (destroyField) {
      destroyField.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }
}
